// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overview-boxes .box[data-v-78171e59]:hover{align-items:center;justify-content:center;padding:15px 14px;border-radius:12px;box-shadow:0 5px 10px rgba(0,0,0,.884)}", ""]);
// Exports
module.exports = exports;
